// extracted by mini-css-extract-plugin
export default {"buttons":"ModalButtons_buttons__GffYa","ok":"ModalButtons_ok__6kxm4"};